import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { MenuElement } from 'src/app/shared/model/menu-element';

// Definicja menu przystanków zerujących liczniki. Wydzielona z komponentu, bo korzysta z niej także mapa aplikacji.
export function buildResetStopsMenuElements(settings: UserSettingsService): MenuElement[] {
  return [
    {
      name: 'list',
      icon: 'search',
      route: 'list'
    },
    {
      name: 'add',
      icon: 'add_box',
      route: 'add',
      disabled: !settings.shouldAllowEditResetStops()
    }
  ];
}
